import { Dispatch, SetStateAction } from 'react'
import { SelectButton, SelectButtonProps } from 'primereact/selectbutton'
import './SwitchButtonComponent.scss'
import { useTranslation } from 'react-i18next'

interface SwitchButtonProps<T> extends SelectButtonProps {
  selected: T
  setSelected: Dispatch<SetStateAction<T>>
}

export default function SwitchButtonComponent<T>(props: SwitchButtonProps<T>) {
  const { t } = useTranslation()
  const options = [t('dashboard.count'), t('dashboard.percentage')]

  return (
    <div>
      <SelectButton
        value={props.selected}
        options={options}
        className="selectButton"
        multiple={false}
        onChange={(e) => props?.setSelected(e.value)}
        {...props}
      />
    </div>
  )
}
